import { Component, Input } from '@angular/core';
import { NDCRegistrationCard } from 'src/app/model/card/ndc-registration-card';

@Component({
  selector: 'app-ndc-registrations-saleshub-card',
  templateUrl: './ndc-registrations-saleshub-card.component.html',
  styleUrls: ['./ndc-registrations-saleshub-card.component.scss']
})
export class NdcRegistrationsSaleshubCardComponent {
  @Input() salesHubCategory: NDCRegistrationCard[] = [];
  constructor() {}
}
